import { sortRowsByGrouping } from '../../appContainer';

export default class CreateAllocationsRowData {
  execute(source) {
    const resultArray = [];
    source.items.forEach((row) => {
      row.values.name = row.name;
      row.values.itemId = row.itemId;
      row.values.columnCategoryId = source.columnCategoryId;
      row.values.itemsCategoryId = source.itemsCategoryId;
      row.values.cellClass = 'text-center';
      row.values.isHidden = this.hiddenItems.has(Number(row.itemId));
      row.values.format = 'H';
      row.values.onCellValueChanged = (event) => {
        if (event.colDef.field === 'name') {
          this.handleProjectNameChange(event);
        } else {
          this.handleCellValueChange(event);
        }
      };
      row.values.editable = (params) => {
        if (params.colDef.field !== 'name' && !params.data.parent) {
          const columnId = params.column.colId;
          const childrenSum = params.data.subitems.reduce((acc, item) => {
            return acc + item[columnId];
          }, 0);

          if (childrenSum === 0) {
            return true;
          }

          return false;
        }

        return true;
      };
      row.values.parentItemId = row.parentItemId;
      resultArray.push(row.values);
    });

    const sortedRowData = sortRowsByGrouping.execute(resultArray);
    return sortedRowData;
  }
}
